<template>
  <div class="homepage">
    <audio-hero
      headline-variation="headlineB" />

    <main-features
      headline-variation="variationHeadline"
      :show-trial-end-date="showTrialEndDate" />

    <statistics />

    <use-cases
      :show-trial-end-date="showTrialEndDate" />

    <trial-duration-explanation
      v-if="showPricing"
      :subscription-plan="yearlyPlan" />

    <app-reviews
      :show-trial-end-date="showTrialEndDate" />

    <category-explorer
      :categories="categoryProps"
      :show-trial-end-date="showTrialEndDate" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AudioHero from "@/features/audio-hero/audio-hero";
import Statistics from "@/features/statistics/statistics";
import UseCases from "@/features/use-cases/use-cases";
import CategoryExplorer from "@/component-library/category-explorer";
import MainFeatures from "@/pages/book/components/main-features";
import AppReviews from "@/features/app-reviews";
import TrialDurationExplanation from "@/features/trial-duration-explanation/components/trial-duration-explanation";

export default {
  name: "HomepageTempPage",
  components: {
    AudioHero,
    Statistics,
    UseCases,
    TrialDurationExplanation,
    AppReviews,
    MainFeatures,
    CategoryExplorer
  },
  props: {
    categoryProps: {
      type: Array,
      default: () => [],
      required: true
    },
    abTestCategories: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters("plans", ["yearlyPlan"]),
    showTrialEndDate() {
      return false;
    },
    showPricing () {
      return !!this.yearlyPlan;
    }
  }
};
</script>
